import { render, staticRenderFns } from "./CardSlot.vue?vue&type=template&id=49254c7d&scoped=true"
import script from "./CardSlot.vue?vue&type=script&lang=js"
export * from "./CardSlot.vue?vue&type=script&lang=js"
import style0 from "./CardSlot.vue?vue&type=style&index=0&id=49254c7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49254c7d",
  null
  
)

export default component.exports